import { useEffect, RefObject } from 'react';

type Event = MouseEvent | TouchEvent;

const useOutsideClick = <T extends HTMLElement = HTMLElement>(ref: RefObject<T>, callback: (event: Event) => void) => {
  useEffect(() => {
    const listener = (event: Event) => {
      if (!ref?.current || ref?.current.contains(event?.target as Node)) {
        return;
      }

      callback(event); // Call the callback only if the click is outside of the element passed.
    };

    document.addEventListener('click', listener);

    return () => {
      document.removeEventListener('click', listener);
    };
  }, [callback]); // Reload only if ref or callback changes
};

export default useOutsideClick;
